import { render, staticRenderFns } from "./addOrEdit.vue?vue&type=template&id=5815e79c&scoped=true&"
import script from "./addOrEdit.vue?vue&type=script&lang=js&"
export * from "./addOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./addOrEdit.vue?vue&type=style&index=0&id=5815e79c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5815e79c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5815e79c')) {
      api.createRecord('5815e79c', component.options)
    } else {
      api.reload('5815e79c', component.options)
    }
    module.hot.accept("./addOrEdit.vue?vue&type=template&id=5815e79c&scoped=true&", function () {
      api.rerender('5815e79c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/highRiskDataManagement/components/addOrEdit.vue"
export default component.exports